export const ONLOAD_ASSIGN_ANALYTICS = Object.freeze({
	ACTION: 'viewed',
	ACTION_SUBJECT: 'assign',
});
